import type { ActiveBan } from '@app/common';

/**
 * Suspension signal between the API layer and the auth provider.
 *
 * The same shape as `sessionExpiry`, and for the same reason: `api/` cannot import
 * `context/`, so the 403 handler publishes here and `AuthProvider` subscribes.
 * Kept as its own module rather than a second event on `sessionExpiry` because the
 * two mean opposite things to the user — one says "sign in again", the other says
 * "signing in again will not help" — and only this one carries a payload.
 */

type AccountSuspendedListener = (ban: ActiveBan) => void;

const listeners = new Set<AccountSuspendedListener>();

/** Returns its own unsubscribe function so callers can clean up from a `useEffect`. */
export function onAccountSuspended(listener: AccountSuspendedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyAccountSuspended(ban: ActiveBan): void {
  listeners.forEach((listener) => listener(ban));
}
